import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/upr-api";

export default function Tags() {
  const [tags, setTags] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/releases/tags")
      .then(({ data }) => setTags(Array.isArray(data) ? data : []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-[70vh] px-6 md:px-12 lg:px-16 pt-16 md:pt-24 pb-24" data-testid="tags-page">
      <div className="upr-eyebrow mb-4">Explore · Tags</div>
      <h1 className="font-heading font-black tracking-tighter text-5xl md:text-7xl leading-[0.9] mb-8" style={{ letterSpacing: "-0.03em" }}>
        Browse by tag.
      </h1>
      <p className="max-w-2xl text-base md:text-lg mb-12" style={{ color: "var(--upr-muted)" }}>
        Each tag opens the catalogue filtered to releases tagged with it. Combine them with the search on the Music page for finer digging.
      </p>

      {loading ? (
        <div className="text-sm" style={{ color: "var(--upr-muted)" }} data-testid="tags-loading">Loading…</div>
      ) : tags.length === 0 ? (
        <div className="text-sm" style={{ color: "var(--upr-muted)" }} data-testid="tags-empty">
          No tags yet. Add some tags to your releases in the admin dashboard.
        </div>
      ) : (
        <div className="flex flex-wrap gap-3" data-testid="tags-grid">
          {tags.map((t) => (
            <Link
              key={t.tag}
              to={`/?tag=${encodeURIComponent(String(t.tag).toLowerCase())}`}
              className="inline-flex items-center gap-2 px-4 py-2 border font-heading uppercase tracking-widest text-sm transition-colors hover:border-[color:var(--upr-primary)] hover:text-[color:var(--upr-primary)]"
              style={{ background: "var(--upr-surface)", color: "var(--upr-fg)", borderColor: "var(--upr-border)" }}
              data-testid={`tags-page-chip-${String(t.tag).toLowerCase().replace(/\s+/g, "-")}`}
            >
              <span>{t.tag}</span>
              <span className="upr-eyebrow" style={{ fontSize: "0.6rem", color: "var(--upr-muted)" }}>{t.count}</span>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
